import { DownloadInfoProps } from '../Button/Button'
import { DownloadEmail } from '../DownloadEmail/DownloadEmail'
import { styles, PopupFormVariants } from './PopupForm.css'
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'

interface PopupFormProps extends PopupFormVariants {
	downloadInfo: DownloadInfoProps
	_key: string
  isOpen: boolean
  setIsOpen: (value: boolean) => void
}

export const PopupForm: React.FC<PopupFormProps> = ({ _key, downloadInfo, isOpen, setIsOpen }) => {
  const { base, backDrop, wrapper, panel } = styles()

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} className={base()} transition>
      <DialogBackdrop className={backDrop()} />
      <div className={wrapper()}>
        <DialogPanel className={panel()}>
					<DownloadEmail _key={_key} infos={downloadInfo} theme='light' noPx center noMaxWidth noMt />
        </DialogPanel>
      </div>
    </Dialog>
  )
}
